import { render, staticRenderFns } from "./gl-modal.vue?vue&type=template&id=674ac376&"
import script from "./gl-modal.vue?vue&type=script&lang=js&"
export * from "./gl-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports